export default "__VITE_ASSET__6590fb67__"